import { SearchInput } from "@/core/components/search-input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/core/components/ui/select";
import { Stack } from "@/core/components/ui/stack";
import type { ApDayRange } from "@/accounts-payable/query";
import type { ApDocumentType } from "@/accounts-payable/types";
import { DayFilter, type DayField } from "./day-filter";

export interface DocumentStatusFilter {
  key: string;
  label: string;
}

/**
 * The filter row above an AP document list (Invoices, Receipts): status,
 * the added or reviewed day, and search. Filtering itself runs server-side.
 */
export const DocumentListFilters = ({
  kind,
  statusFilters,
  status,
  onStatusChange,
  dayField,
  onDayFieldChange,
  dayRange,
  onDayRangeChange,
  search,
  onSearchChange,
  searchPlaceholder,
}: {
  kind: ApDocumentType;
  statusFilters: DocumentStatusFilter[];
  status: string;
  onStatusChange: (key: string) => void;
  dayField: DayField;
  onDayFieldChange: (field: DayField) => void;
  dayRange: ApDayRange | null;
  onDayRangeChange: (range: ApDayRange | null) => void;
  search: string;
  onSearchChange: (value: string) => void;
  searchPlaceholder: string;
}) => (
  <Stack
    direction="row"
    justify="between"
    align="center"
    gap="sm"
    fullWidth
    className="flex-none flex-wrap py-4"
  >
    <Stack direction="row" gap="sm" align="center" className="flex-wrap">
      <Select value={status} onValueChange={onStatusChange}>
        <SelectTrigger aria-label="Filter by status" className="w-56 gap-2">
          <Stack direction="row" gap="xs" align="center">
            <span className="text-secondary-text">Status:</span>
            <SelectValue />
          </Stack>
        </SelectTrigger>
        <SelectContent align="end">
          {statusFilters.map((f) => (
            <SelectItem key={f.key} value={f.key}>
              {f.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <DayFilter
        kind={kind}
        field={dayField}
        onFieldChange={onDayFieldChange}
        value={dayRange}
        onChange={onDayRangeChange}
      />
    </Stack>
    <SearchInput
      placeholder={searchPlaceholder}
      value={search}
      onChange={onSearchChange}
      className="bg-card"
    />
  </Stack>
);
